// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  background: #121212;
}

body {
  margin: 0;
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

/* Manual set style properties to show overflow TableChart values without cutoff */
.MuiDataGrid-cell--textLeft {
  max-width: 600px !important;
}

.MuiDataGrid-virtualScroller {
  overflow-x: auto !important;
}

.Menu-Options {
  color: #6656f8;
  cursor: pointer;
  font-size: 20px;
}

.Menu-Options:hover {
  text-decoration: underline;
}

.Hover-Underline:hover {
  text-decoration: underline !important;
}

.rotated {
  transform: rotate(180deg);
}

input[type="file"] {
  display: none;
}

.round-image {
  border-radius: 2px;
}

.PrivatePickersSlideTransition-root {
  min-height: 200px !important;
}

/* Fix for table dividing lines to make them continuous without breaks */
.MuiTableContainer-root .MuiTable-root {
  border-collapse: collapse;
}

.MuiTableContainer-root .MuiTableRow-root {
  border-bottom: 1px solid rgba(81, 81, 81, 1);
}

.MuiTableContainer-root .MuiTableCell-root {
  border-bottom: none;
}

.MuiTableContainer-root .MuiTableBody-root .MuiTableRow-root:last-child {
  border-bottom: none;
}

/* Specific class for continuous table borders */
.continuous-table-borders .MuiTable-root {
  border-spacing: 0;
}

.continuous-table-borders .MuiTableRow-root {
  box-shadow: none;
}

.continuous-table-borders .MuiTableRow-root td {
  border-bottom: none;
}

.continuous-table-borders .MuiTableRow-root {
  border-bottom: 1px solid rgba(81, 81, 81, 1);
}

.continuous-table-borders .MuiTableBody-root .MuiTableRow-root:last-child {
  border-bottom: none;
}

/* Specific styling for continuous table */
.continuous-table {
  border-collapse: collapse !important;
}

.continuous-table .MuiTableRow-root {
  border-bottom: 1px solid rgba(81, 81, 81, 1) !important;
}

.continuous-table .MuiTableCell-root {
  border-bottom: none !important;
  box-shadow: none !important;
}

.continuous-table .MuiTableBody-root .MuiTableRow-root:last-child {
  border-bottom: none !important;
}

/* Global table styles to ensure continuous horizontal dividers */
table {
  border-collapse: collapse !important;
}

.MuiTable-root {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
}

/* Remove default Material UI table cell borders */
.MuiTableCell-root {
  border-bottom: none !important;
}

/* Add consistent row borders instead of cell borders */
.MuiTableRow-root {
  border-bottom: 1px solid rgba(81, 81, 81, 1) !important;
}

/* Remove border from last row in table body to avoid double borders */
.MuiTableBody-root .MuiTableRow-root:last-child {
  border-bottom: none !important;
}

/* Remove box-shadow that might be causing visual breaks */
.MuiTableCell-root, .MuiTableRow-root {
  box-shadow: none !important;
}

/* Ensure all table cells have vertically centered content */
.MuiTableCell-root {
  vertical-align: middle !important;
}

/* Ensure cell content is vertically centered when using display: flex */
.MuiTableCell-root[style*="display: flex"] {
  align-items: center !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT;2DACyD;EACzD,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,+EAA+E;AACjF;;AAEA,kFAAkF;AAClF;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iEAAiE;AACjE;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA,kDAAkD;AAClD;EACE,8BAA8B;AAChC;;AAEA,uDAAuD;AACvD;EACE,uDAAuD;AACzD;;AAEA,sEAAsE;AACtE;EACE,8BAA8B;AAChC;;AAEA,0DAA0D;AAC1D;EACE,2BAA2B;AAC7B;;AAEA,4DAA4D;AAC5D;EACE,iCAAiC;AACnC;;AAEA,wEAAwE;AACxE;EACE,8BAA8B;AAChC","sourcesContent":["html,\nbody {\n  background: #121212;\n}\n\nbody {\n  margin: 0;\n  font-family: Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\",\n    \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #fff;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n/* Manual set style properties to show overflow TableChart values without cutoff */\n.MuiDataGrid-cell--textLeft {\n  max-width: 600px !important;\n}\n\n.MuiDataGrid-virtualScroller {\n  overflow-x: auto !important;\n}\n\n.Menu-Options {\n  color: #6656f8;\n  cursor: pointer;\n  font-size: 20px;\n}\n\n.Menu-Options:hover {\n  text-decoration: underline;\n}\n\n.Hover-Underline:hover {\n  text-decoration: underline !important;\n}\n\n.rotated {\n  transform: rotate(180deg);\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n\n.round-image {\n  border-radius: 2px;\n}\n\n.PrivatePickersSlideTransition-root {\n  min-height: 200px !important;\n}\n\n/* Fix for table dividing lines to make them continuous without breaks */\n.MuiTableContainer-root .MuiTable-root {\n  border-collapse: collapse;\n}\n\n.MuiTableContainer-root .MuiTableRow-root {\n  border-bottom: 1px solid rgba(81, 81, 81, 1);\n}\n\n.MuiTableContainer-root .MuiTableCell-root {\n  border-bottom: none;\n}\n\n.MuiTableContainer-root .MuiTableBody-root .MuiTableRow-root:last-child {\n  border-bottom: none;\n}\n\n/* Specific class for continuous table borders */\n.continuous-table-borders .MuiTable-root {\n  border-spacing: 0;\n}\n\n.continuous-table-borders .MuiTableRow-root {\n  box-shadow: none;\n}\n\n.continuous-table-borders .MuiTableRow-root td {\n  border-bottom: none;\n}\n\n.continuous-table-borders .MuiTableRow-root {\n  border-bottom: 1px solid rgba(81, 81, 81, 1);\n}\n\n.continuous-table-borders .MuiTableBody-root .MuiTableRow-root:last-child {\n  border-bottom: none;\n}\n\n/* Specific styling for continuous table */\n.continuous-table {\n  border-collapse: collapse !important;\n}\n\n.continuous-table .MuiTableRow-root {\n  border-bottom: 1px solid rgba(81, 81, 81, 1) !important;\n}\n\n.continuous-table .MuiTableCell-root {\n  border-bottom: none !important;\n  box-shadow: none !important;\n}\n\n.continuous-table .MuiTableBody-root .MuiTableRow-root:last-child {\n  border-bottom: none !important;\n}\n\n/* Global table styles to ensure continuous horizontal dividers */\ntable {\n  border-collapse: collapse !important;\n}\n\n.MuiTable-root {\n  border-collapse: collapse !important;\n  border-spacing: 0 !important;\n}\n\n/* Remove default Material UI table cell borders */\n.MuiTableCell-root {\n  border-bottom: none !important;\n}\n\n/* Add consistent row borders instead of cell borders */\n.MuiTableRow-root {\n  border-bottom: 1px solid rgba(81, 81, 81, 1) !important;\n}\n\n/* Remove border from last row in table body to avoid double borders */\n.MuiTableBody-root .MuiTableRow-root:last-child {\n  border-bottom: none !important;\n}\n\n/* Remove box-shadow that might be causing visual breaks */\n.MuiTableCell-root, .MuiTableRow-root {\n  box-shadow: none !important;\n}\n\n/* Ensure all table cells have vertically centered content */\n.MuiTableCell-root {\n  vertical-align: middle !important;\n}\n\n/* Ensure cell content is vertically centered when using display: flex */\n.MuiTableCell-root[style*=\"display: flex\"] {\n  align-items: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
